<template>
  <div class="content">
    <div class="from_cont">
      <div class="logo">
        <div class="img">
          <img src="../assets/logo.svg" />
        </div>
        <div class="name">GalaxyQuantitativ</div>
      </div>
      <div class="tip_img">登录</div>
    </div>

    <div class="data_cont">
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        status-icon
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item prop="UserName">
          <el-input
            v-model="ruleForm.UserName"
            placeholder="用户名/邮箱/手机号码"
          >
            <template #prefix>
              <div class="data__icon">
                <img src="../assets/user.png" />
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="Password">
          <el-input
            type="password"
            v-model="ruleForm.Password"
            placeholder="请输入登录密码"
          >
            <template #prefix>
              <div class="data__icon">
                <img src="../assets/password.png" />
              </div>
            </template>
            <template #suffix>
              <div
                class="code_btn"
                @click="router.push('/retrieve')"
                type="info"
              >
                忘记密码
              </div>
            </template>
          </el-input>
        </el-form-item>

        <div class="flex space_between" style="margin-top: 16px">
          <div class="sub_bnt back_home" @click="router.replace('/home')">
            <div class="name">返回主页</div>
          </div>
          <div class="sub_bnt" @click="submit">
            <div class="name">立即登录</div>
            <div class="img">
              <img src="../assets/right.png" />
            </div>
          </div>
        </div>
      </el-form>

      <div class="tip_cont" @click="router.push('/sign')">创建一个账号？</div>
    </div>

    <div class="logo_btm">
      <img src="../assets/btmimg.png" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";

import router from "@/router";
import { LoginPost } from "@/api/api";
const ruleForm = reactive({
  UserName: "",
  Password: "",
});
onMounted(() => {
  const resetAutofillStyle = (input: HTMLInputElement) => {
    setTimeout(() => {
      input.style.backgroundColor = "";
      input.style.color = "";
    }, 50);
  };
});

const ruleFormRef = ref<any | null>(null);

function submit() {
  ruleFormRef.value.validate((valid: any) => {
    if (valid) {
      let data = {
        UserName: ruleForm.UserName,
        Password: ruleForm.Password,
      };
      LoginPost(data).then((res: any) => {
        if (res?.code == 0) {
          ElMessage({
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("appToken", res.data.token);
          router.replace("/home2");
        } else {
          console.log(res?.message);

          ElMessage({
            message: res?.message || "登录失败",
            type: "error",
          });
        }
      });
    } else {
      console.log("错误提交!");
      return false;
    }
  });
}

const validateUserName = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入正确信息"));
  } else {
    if (ruleForm.UserName !== "") {
      if (!ruleFormRef.value) return;
    }
    callback();
  }
};

const rules = reactive<FormRules<typeof ruleForm>>({
  UserName: [{ validator: validateUserName, trigger: "blur" }],
  Password: [{ validator: validateUserName, trigger: "blur" }],
});
</script>
<style lang="scss" scoped>
.content {
  background-color: #000;
  padding: 26px 0;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(../assets/5e42c301e259732f49c2ea488f7d916.png);
  height: 100vh;
  box-sizing: border-box;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  .logo_btm {
    width: 386px;
    position: absolute;
    bottom: 0;
    right: 0;
    img {
      width: 100%;
    }
  }
}
.from_cont {
  max-width: 1200px;
  .logo {
    display: flex;
    align-content: center;
    .img {
      width: 88px;
      height: 88px;
    }
    img {
      width: 100%;
    }
    .name {
      display: flex;
      align-items: center;
      font-size: 38px;
      color: #ffffff;
    }
  }
  .tip_img {
    font-size: 50px;
    font-weight: bold;
    color: #fff;
    margin: auto;
    // width: 78px;
    text-align: center;
    margin-bottom: 38px;
    img {
      width: 100%;
    }
  }
}

.data__icon {
  width: 20px;
  display: flex;
  align-items: center;
  margin-right: 20px !important;
  img {
    width: 100%;
  }
}
.data_cont {
  width: 964px;
}

::v-deep .el-input__inner {
  padding: 10px 0;
}
::v-deep .el-input--prefix .el-input__inner::placeholder {
  color: #a1a1aa !important;
  font-size: 18px;
}

::v-deep .el-input__inner {
  padding: 32px 0 !important;
  font-size: 18px;
  color: #fff;
}
::v-deep .el-input__wrapper {
  background-color: #18181b !important;
  border-radius: 12px !important;
  padding-left: 24px;
}
::v-deep .el-input__wrapper {
  box-shadow: none !important;
}
.el-form-item {
  margin-bottom: 37px !important;
}
.sub_bnt {
  cursor: pointer;
  width: 43%;
  margin-top: 32px;
  font-size: 24px;
  background-color: rgba(157, 255, 123, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 16px;
  color: #000;
  .img {
    width: 30px;
    height: 30px;
    margin-left: 10px;
  }
  img {
    width: 100%;
  }
}
.back_home {
  background-color: #18181b;
  color: #a1a1aa;
}
.tip_cont {
  text-align: center;
  color: rgb(113, 113, 122);
  font-size: 20px;
  cursor: pointer;
  margin: auto;
  margin-top: 28px;

  img {
    width: 100%;
  }
}
v-deep input:-internal-autofill,
input:-internal-autofill-selected {
  background-color: white !important;
  color: black !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  transition: background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s;
}
.code_btn {
  font-size: 20px;
  width: 5em;
  position: absolute;
  right: -6em;
  cursor: pointer;
}
</style>
